module.exports = __webpack_public_path__ + "img/end-meeting-alt.787f17ac.svg";